import React from 'react';
import classes from "./SectionHeader.module.css";

export default function SectionHeader({title, heading, headingWhite, className}) {
  return (
    <div className={`${classes.mainDiv} ${className}`}>
      <div className={classes.topDiv}>
        <p className={`f-20 fw-600 ${classes.title}`}>{title}</p>
        <span className={classes.lineBar}></span>
      </div>
        <p className={`f-45 sm-f-45 fw-600 ${classes.heading} ${headingWhite && classes.white}`}>{heading}</p>
    </div>
  )
}
